import bundleFeature from '../../utils/bundleFeature'

import { CommentsContainerComponent } from './components'
import sagas from './sagas'
import actions from './actions'
import reducer from './reducer'
import selectors from './selectors'

export default bundleFeature({
  Component: CommentsContainerComponent,
  actions,
  sagas,
  reducer,
  selectors,
})
